<template>
  <div class="d-flex w-100 p-3 h-100 zalo-account">
    <el-dialog :visible.sync="dialogVisible" title="Đăng nhập tài khoản Zalo" v-if="dialogVisible" width="500px"
               destroy-on-close :close-on-click-modal="false">
      <el-tabs type="border-card" class="h-100">
        <el-tab-pane label="Đăng nhập bằng mã QR">
          <LoginZalo @success="loginSuccessfully" :selectedAccountId="selectedAccountId" />
        </el-tab-pane>
        <!-- <el-tab-pane label="Đăng nhập bằng điện thoại">
          <LoginWithPhone @success="loginSuccessfully" />
        </el-tab-pane> -->
      </el-tabs>
    </el-dialog>
    <el-dialog :visible.sync="dialogV2Visible" title="Thêm liên kết từ xa với QRCode" v-if="dialogV2Visible"
               width="450px"
               destroy-on-close :close-on-click-modal="false">
      <div>
        <div class="px-2 py-1 d-flex" style="background-color: #fff; border: 1px solid #DCDFE9; border-radius: 4px">
          <div class="text-primary ml-1 text-1-line">
            {{ getLoginUrl() }}
          </div>
          <div class="text float-end mx-2 ">
            <el-tooltip class="item" effect="dark" content="Sao chép" placement="top">
              <i class="pointer   el-icon-copy-document mt-1" @click="copyLink(getLoginUrl())">
              </i>
            </el-tooltip>
          </div>
        </div>
        <div class="text-break text-danger">
          <div class="mt-3">- Cho phép liên kết tài khoản Zalo từ xa không cần đăng nhập tài khoản Salework</div>
          <div class="mt-1">- Link liên hết chỉ có hiệu lực trong vòng 01 ngày</div>
          <div class="mt-1">- Bấm sao chép để lấy link liên kết</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="'Đặt biệt danh cho :' + selectedAcc.zaloName" width="500px" v-if="showPopOverSwName"
               :visible.sync="showPopOverSwName" destroy-on-close>
      <div>
        <el-input placeholder="Nhập biệt danh" type="textarea" :rows="3" v-model="selectedAcc.swName"
                  resize="none"></el-input>
        <div class="d-flex justify-content-end mt-2">
          <el-button type="primary" size="mini" plain @click="saveSwName()">Lưu</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="'Duy trì kết nối tài khoản :' + selectedAcc.zaloName" width="500px" v-if="dialogAutoLoginVisible"
               :visible.sync="dialogAutoLoginVisible" destroy-on-close>
      <div>
        <el-input placeholder="Nhập mật khẩu" show-password v-model="password"
                  resize="none"></el-input>
        <div class="d-flex justify-content-end mt-2" v-if="password.length>0">
          <el-button type="primary" size="mini" plain @click="saveAutoLogin()">Lưu</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog v-if="employeeDialogVisible" :visible.sync="employeeDialogVisible" title="Phân quyền nhân viên"
               destroy-on-close>
      <EmployeeAuthorization :accountId="selectedAccountId" :closeDialog="closeDialog" />
    </el-dialog>

    <div class="flex-1 mt-2">
      <div class="p-1">
        <div class="font-size-18 fw-bold">Liên kết tài khoản</div>
        <div class="mt-1 font-size-14">Đừng quên liên kết thêm các tài khoản khác của bạn tại đây!</div>
        <div class="font-size-14">
          Thông tin của bạn an toàn tuyệt đối dựa trên
          <span
            class="text-info fw-bold pointer"
            @click="
              newTab(
                'https://salework.net/privacy-policy/#:~:text=Ch%C3%BAng%20t%C3%B4i%20cung%20c%E1%BA%A5p%20cho,m%C3%ACnh%20b%E1%BA%A5t%20k%E1%BB%B3%20l%C3%BAc%20n%C3%A0o'
              )
            "
          >
            Chính sách bảo mật
          </span>
          của chúng tôi.
          <div class="font-size-14">
            Bằng việc liên kết tài khoản là bạn đã đồng ý với
            <span class="text-info fw-bold pointer"
                  @click="newTab('https://salework.net/dieu-khoan-su-dung-salework-zalo')">
              Điều khoản và quy định sử dụng
            </span>
            của Salework Zalo.
          </div>
        </div>
      </div>
      <div class="zalo-account-box">
        <div class="zalo-account-header d-flex mt-3">
          <el-image src="/assets/icon/icon_zalo.png" style="width: 30px;height: 30px" />
          <div class="fw-bold font-size-16">Danh sách tài khoản</div>
          <div class="d-flex justify-content-end align-self-end ">
            <el-select @change="changeStatus" v-model="statusAccount" placeholder="Chọn trạng thái tài khoản" size="">
              <el-option label="Tất cả trạng thái" :value="''"></el-option>
              <el-option
                v-for="account in ['ACTIVE','OFF']"
                :key="account"
                :label="account === 'ACTIVE' ? 'Đang hoạt động' : 'Cần đăng nhập lại'"
                :value="account"
              ></el-option>
            </el-select>
          </div>
          <el-input placeholder="Tìm kiếm tên tài khoản" v-model="searchText" class="w-25" />
          <div class="flex-1" />
          <el-button size="medium" type="primary" @click="exportAccount">
            Xuất excel
          </el-button>
          <el-button size="medium" type="secondary" plain @click="openLoginV2Dialog">
            Liên kết từ xa
          </el-button>
          <el-button size="medium" type="primary" plain @click="openLoginDialog" v-if="accounts.length > 0">
            Thêm liên kết
          </el-button>
        </div>
        <div class="zalo-account-info">
          <div v-if="accounts.length > 0" class="d-flex p-3 fw-bold mb-2 font-size-15">
            <div style="width: 60px" class="justify-content-center d-flex">STT</div>
            <div class="zalo-account-list-item-1">Tên đăng nhập</div>
            <div class="zalo-account-list-item-3 text-center">Bạn bè</div>
            <div class="zalo-account-list-item-3 text-center" v-if="app.user.checkIpWhiteList">Duy trì kết nối</div>
            <div class="zalo-account-list-item-3 text-center">Trạng thái</div>
            <div class="zalo-account-list-item-5 text-center" v-if="showActionAccount()">Hành động</div>
          </div>
          <div class="zalo-account-list bg-white" v-if="accounts.length > 0">
            <div v-for="(account, index) in viewAccount" :key="index">
              <div class=" font-size-13">
                <div class="divider-custom mx-2" v-if="index == 0" />
                <div class="d-flex p-3  mb-2 ">
                  <div style="width: 60px;"
                       class="justify-content-center d-flex fw-semibold align-item-center font-size-18">{{ index + 1 }}
                  </div>
                  <div class="zalo-account-list-item-1">
                    <div class="d-flex align-items-center gap-2">
                      <el-avatar :src="account.avatar"></el-avatar>
                      <div>
                        <div class="d-flex">
                          <div class="fw-bold">{{ account.displayName }}</div>
                          <el-tooltip class="item pointer" effect="dark" content="Đặt biệt danh cho tài khoản"
                                      slot="reference" placement="top">
                            <i class="el-icon-edit-outline font-size-16 fw-bolder mt-1 mx-2" style="color: #0A58C0"
                               @click="showPopOver(account)" />
                          </el-tooltip>
                        </div>
                        <div class="font-size-14 text-danger" v-if="account.swName && account.swName.length > 0">Biệt
                          danh : {{ account.swName }}
                        </div>
                        <div class="font-size-14 " v-if="account.phoneNumber && account.phoneNumber.length > 0">Số điện thoại : {{ account.phoneNumber }}
                        </div>
                        <div class="d-flex text-primary font-size-14" v-if="showId()">
                          <div>ID : {{ account.accountId }}</div>
                          <el-tooltip class="item mx-1" effect="dark" content="Sao chép" placement="top">
                            <i class="pointer el-icon-copy-document mt-1"
                               @click="copyToClipboard(account.accountId,'Sao chép ID thành công !')">
                            </i></el-tooltip>
                        </div>
                        <div>Cập nhật lúc : {{ convertTime(account.updateAt) }}</div>
                      </div>
                    </div>
                  </div>


                  <div class="text-center zalo-account-list-item-3">
                    <div class="font-size-13 text-gray">
                      {{ getCountFriend(account) }}
                    </div>
                  </div>
                  <div class="text-center zalo-account-list-item-3" v-if="app.user.checkIpWhiteList">
                    <div class="font-size-13 text-gray">
                      <el-switch v-model="account.autoLogin" @change="autoLogin(account)"
                                 :disabled="account.status!=='ACTIVE'" />
                    </div>
                  </div>
                  <div class="text-center zalo-account-list-item-3"
                       v-bind:class="[account.status === 'ACTIVE' ? 'text-success' : 'text-danger']">
                    <div class="font-size-13 text-gray">
                      {{ account.status === "ACTIVE" ? "Đang hoạt động" : "Cần đăng nhập lại" }}
                    </div>
                  </div>
                  <div class="zalo-account-list-item-5 text-center d-flex  justify-content-center"
                       v-if="showActionAccount()">
                    <div>
                      <!--                      <el-button size="mini" @click="relogin(account)" v-if="account.status!='ACTIVE'">Đăng nhập lại-->
                      <!--                      </el-button>-->
                      <el-button size="mini" @click="handleDelete(account)"><span class="text-danger">Xoá</span>
                      </el-button>
                      <el-button
                        size="mini"
                        @click="disconnect(account)"
                        :disabled="account.status !== 'ACTIVE'"
                      >
                        Ngắt kết nối
                      </el-button>
                    </div>
                  </div>
                </div>
                <div class="divider-custom mx-2" v-if="index < accounts.length - 1" />
              </div>
            </div>
          </div>
          <div v-else>
            <div class="d-flex my-4">
              <div style="width: 40px" />
              <div style="width: 60px;height: 60px;">
                <el-image src="/assets/icon/ic_add.svg" />
              </div>
              <div class="justify-content-center text-center flex-1 font-size-14">
                <div>
                  Liên kết tài khoản Zalo với Salework, giúp đồng bộ quản lý tin nhắn,
                  <br />
                  danh sách khách hàng.
                </div>
                <el-button size="medium" type="primary" class="mt-2" @click="dialogVisible = true">Liên kết ngay
                </el-button>
              </div>
              <div style="width: 70px;height: 30px"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';

export default {
  components: {
    LoginZalo: () => import("@/components/LoginZalo"),
    EmployeeAuthorization: () => import("@/components/EmployeeAuthorization"),
    // LoginWithPhone: () => import("./LoginWithPhone.vue")
  },
  computed: {
    viewAccount() {
      return this.accounts
        .filter(s => s.zaloName.toLowerCase().includes(this.searchText.toLowerCase())
          || s.phoneNumber.toLowerCase().includes(this.searchText.toLowerCase())
          || (s.swName != null && s.swName.toLowerCase().includes(this.searchText.toLowerCase()))
          || (this.showId() && s.accountId.toLowerCase().includes(this.searchText.toLowerCase())))
        .filter(s => {
          if (this.statusAccount.length === 0) {
            return true;
          } else {
            if (this.statusAccount === "ACTIVE") {
              return s.status === "ACTIVE";
            } else {
              return s.status !== "ACTIVE";
            }
          }
        });
    }
  },
  data() {
    return {
      accounts: [],
      dialogVisible: false,
      dialogV2Visible: false,
      dialogAutoLoginVisible: false,
      selectedAccountId: "",
      employeeDialogVisible: false,
      searchText: "",
      statusAccount: "",
      selectedAcc: {},
      showPopOverSwName: false,
      password: "",
      countFriendRes: {}
    };
  },
  methods: {
    showActionAccount() {
      return this.app.user.type == 'ADMIN' || this.app.manageAccounts;
    },
    copyLink(link) {
      const el = document.createElement("textarea");
      el.value = link;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.alert("success", "Sao chép thành công!");
    },
    getLoginUrl() {
      return "https://zalo.salework.net/loginZaloV2?" + "&cToken=" + localStorage.getItem("loginV2Token");
    },
    autoLogin(account) {
      if (account.autoLogin) {
        this.password = "";
        this.selectedAcc = account;
        this.dialogAutoLoginVisible = true;
      }
    },
    disconnect(account) {
      this.$confirm(`Bạn chắc chắn muốn ngắt kết nối tài khoản ${account.zaloName} này?`, "Warning", {
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Huỷ",
        type: "warning"
      }).then(() => {
        this.$http
          .put(`/api/account/off?accountId=${account.accountId}`)
          .then(() => {
            this.alert("success", "Ngắt kết nối tài khoản thành công");
            const target = this.accounts.find(acc => acc.accountId === account.accountId);
            if (target) {
              target.status = "OFF";
            }
            this.fetchAccountList();
          })
          .catch(() => {
            this.alert("error", "Lỗi xảy ra vui lòng thử lại");
          });
      });
    },
    saveAutoLogin() {
      this.$http
        .get("/api/account/autoConnect", {
          params: {
            accountId: this.selectedAcc.accountId,
            password: this.password
          }
        }).then(() => {
        this.dialogAutoLoginVisible = false;
        this.alert("success", "Cập nhật thành công !");
        this.fetchAccounts();
      });
    },
    showId() {
      if (this.app.user.companyCode == "sw77682" || this.app.user.companyCode == "sw60550" || this.app.user.companyCode == "esbt")
        return true;
      return false;
    },
    showPopOver(account) {
      this.selectedAcc = account;
      this.showPopOverSwName = true;
    },
    saveSwName() {
      this.$http
        .get("/api/account/save", {
          params: {
            swName: this.selectedAcc.swName,
            accountId: this.selectedAcc.accountId
          }
        })
        .then(resp => {
          this.selectedAcc = resp.data;
        });
      this.showPopOverSwName = false;
    },
    changeStatus() {
      return this.viewAccount;
    },
    closeDialog() {
      this.employeeDialogVisible = false;
    },
    handleDelete(account) {
      this.$confirm(`Bạn chắc chắn muốn xoá tài khoản ${account.zaloName} này?`, "Warning", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning"
      }).then(() => {
        this.$http
          .delete(`/api/account/delete?accountId=${account.accountId}`)
          .then(() => {
            this.alert("success", "Xoá tài khoản thành công");
            this.accounts = this.accounts.filter(s => s.accountId !== account.accountId);
            this.fetchAccountList();
          })
          .catch(() => {
            this.alert("error", "Lỗi xảy ra vui lòng thử lại");
          });
      });
    },
    openLoginDialog() {
      if (this.accounts.filter(p => p.status == "ACTIVE").length >= this.app.shopLimit) {
        this.alert("error", "Vui lòng mua thêm số lượng shop bạn muốn liên kết.");
        return;
      }
      this.dialogVisible = true;
    },
    openLoginV2Dialog() {
      this.dialogV2Visible = true;
    },
    loginSuccessfully() {
      this.dialogVisible = false;
      this.fetchAccounts();
      this.fetchAccountList();
    },
    fetchAccounts() {
      this.dialogVisible = false;
      this.$http.get("/api/account/getAll").then(resp => {
        this.accounts = resp.data;
        this.countFriend();
      });
    },
    showEmployeeDialog(account) {
      this.selectedAccountId = account.accountId;
      this.employeeDialogVisible = true;
    },
    relogin(account) {
      if (this.accounts.filter(p => p.status == "ACTIVE").length >= this.app.shopLimit) {
        this.alert("error", "Vui lòng mua thêm số lượng shop bạn muốn liên kết.");
        return;
      }
      this.selectedAccountId = account.accountId;
      this.dialogVisible = true;
    },
    exportAccount() {
      const headers = [
        "ID tài khoản",
        "Tên tài khoản",
        "Ngày sinh",
        "Giới tính",
        "Số điện thoại",
        "Trạng thái",
        "Biệt danh",
        "Thời gian cập nhật",
        "Bạn bè",
      ];

      const data = this.accounts.map(account => ({
        "ID tài khoản": account.accountId,
        "Tên tài khoản": account.displayName,
        "Ngày sinh": account.sdob,
        "Giới tính": account.gender === 0 ? "Nam" : "Nữ",
        "Số điện thoại": account.phoneNumber,
        "Trạng thái": account.status == 'ACTIVE' ? "Đang hoạt động" : "Cần đăng nhập lại",
        "Biệt danh": account.swName,
        "Thời gian cập nhật": this.convertTime(account.updateAt),
        "Bạn bè": this.countFriendRes[account.accountId],
      }));

      const ws = XLSX.utils.json_to_sheet(data, { header: headers, skipHeader: false });
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Accounts");
      XLSX.writeFile(wb, `DanhsachTaikhoan.xlsx`);
    },
    async countFriend() {
      const accountIds = this.accounts.map(acc => acc.accountId);
      let body = {
        accountIds: accountIds
      }
      const res = await this.$http.post("/api/contact/countFriend", body);
      if (res.status == 'success') {
        this.countFriendRes = res.data;
      }
    },
    getCountFriend(account) {
      return this.countFriendRes[account.accountId];
    }
  },
  created() {
    this.$bus.$on("loginSuccessfully", () => {
      this.loginSuccessfully();
    });
    this.fetchAccounts();
  }
};
</script>
